import { useState } from 'react';
import { Check, Copy, KeyRound } from 'lucide-react';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from '@components/ui/dialog';

export function TokenReveal({ title, username, token, onClose }: { title: string; username: string; token: string; onClose: () => void }) {
  const [copied, setCopied] = useState(false);
  const text = `Welcome to the Sport Decisions Library.\nUsername: ${username}\nAccess token: ${token}\nKeep this token private — it will not be shown again.`;
  async function copy() {
    try { await navigator.clipboard.writeText(text); setCopied(true); } catch (e) { console.error(e); }
  }
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md">
        <div className="flex items-center gap-2 text-secondary"><KeyRound className="h-5 w-5 text-primary" /><DialogTitle>{title}</DialogTitle></div>
        <DialogDescription>This access token is shown once. Copy it now and share it securely.</DialogDescription>
        <div className="space-y-2 rounded-xl bg-muted p-4 text-sm">
          <div><span className="text-xs uppercase tracking-wider text-muted-foreground">Username</span><p className="font-mono font-medium">{username}</p></div>
          <div><span className="text-xs uppercase tracking-wider text-muted-foreground">Access token</span><p className="break-all font-mono font-semibold text-primary">{token}</p></div>
        </div>
        <div className="flex justify-end gap-2">
          <button onClick={copy} className="flex h-10 items-center gap-2 rounded-xl border border-border px-4 text-sm font-medium hover:border-primary/40">
            {copied ? <Check className="h-4 w-4 text-primary" /> : <Copy className="h-4 w-4" />} {copied ? 'Copied' : 'Copy welcome message'}
          </button>
          <button onClick={onClose} className="h-10 rounded-xl bg-primary px-4 text-sm font-semibold text-primary-foreground">Done</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
